import XLSX from "xlsx";
  
function example(column, name) {
  var data = [];
  data.push(column);

  var ws = XLSX.utils.aoa_to_sheet(data);
  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, name);
  // /* generate file and send to client */
  XLSX.writeFile(wb, `${name}.xlsx`);
}
  
export default {
  example,
};